import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanResourcesListItem } from "../../../types";

const ScanResourcesTableRegionCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<ScanResourcesListItem>) => (
  <TableSimpleCell {...cellProps}>
    {resource.region ? <TableCellText>{resource.region}</TableCellText> : <TableCellEmpty />}
  </TableSimpleCell>
);

export default ScanResourcesTableRegionCell;
